export default __webpack_public_path__ + "static/media/edit-icon.616c8e71.svg";